import { render, staticRenderFns } from "./FilmUpdateRoot.vue?vue&type=template&id=1296157f&scoped=true&"
import script from "./FilmUpdateRoot.vue?vue&type=script&lang=js&"
export * from "./FilmUpdateRoot.vue?vue&type=script&lang=js&"
import style0 from "./FilmUpdateRoot.vue?vue&type=style&index=0&id=1296157f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1296157f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VContainer,VContent,VFlex,VLayout,VProgressCircular,VTab,VTabItem,VTabs,VTabsItems})
